import React, { useEffect } from "react";
import "./Portfolio.css";
import room from "../../images/room-ed.jpg";
import timer from "../../images/timer-ed.jpg";
import nasims from "../../images/nasims-ed.jpg";
import meet from "../../images/meet.PNG";
import portfolio2 from "../../images/game-ed.jpg";
import artwebsite from "../../images/art-ed.jpg";
import travelapp from "../../images/travel-image.png";
import huddle from "../../images/huddle-ed.jpg";
import testimonial from "../../images/testi-ed.jpg";
import postit from "../../images/postit-ed.jpg";
import onefunnel from "../../images/one-funnel-ed.jpg";
import school from "../../images/ta-website.png";
import ecommerce from "../../images/ecommerce.png";
import adin from "../../images/adin.png";
import classroomhq from "../../images/classroomhq.png";
import adera from "../../images/adera.png";
import nextie from "../../images/nextie.png";

const Portfolio = () => {
  // Scroll To top
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <div className="portfolio">
        <h1 style={{ color: "#5c6e58" }}>
          PORT<span style={{ color: "#ad4328" }}>FOLIO.</span>
        </h1>
        <h5>
          Here are a few projects I have worked and collaborated on. A few are
          confidential projects and so their source codes are unaccessible.
          Enjoy😊
        </h5>

        <div className="cards">
          <div className="card">
            <div className="card-header">In Progress</div>
            <div className="card-image">
              <img src={nextie} className="card-img-top" alt="nextie-site" />
            </div>
            <div className="card-body">
              <h4 className="card-text">
                Nextie (Events Management & Ticketing)
              </h4>
              <p>
                <i>Events Management, Ticketing, RSVP, B2B</i>
              </p>
              <p>NextJs, Material UI</p>
              <a
                href="https://nextie-one.vercel.app"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/adao-website"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Published</div>
            <div className="card-image">
              <img src={adin} className="card-img-top" alt="edtech" />
            </div>
            <div className="card-body">
              <h4 className="card-text">
                Adin University LMS (Student, Instructor & Admin Modules)
              </h4>
              <p>
                <i>Learning Management System, EdTech, Management, L&D</i>
              </p>
              <p>ReactJs </p>
              <a
                href="https://lms.adin-u.com/"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a href="#" target="_blank" rel="noreferrer">
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Complete</div>
            <div className="card-image">
              <img src={classroomhq} className="card-img-top" alt="edtech-2" />
            </div>
            <div className="card-body">
              <h4 className="card-text">
                ClassroomHQ LMS (Student, Teacher & Admin Modules)
              </h4>
              <p>
                <i>Learning Management System, EdTech, Management</i>
              </p>
              <p>ReactJs, Bootstrap</p>
              <a
                href="https://classroomhq-admin.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a href="#" target="_blank" rel="noreferrer">
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Published</div>
            <div className="card-image">
              <img src={artwebsite} className="card-img-top" alt="art-site" />
            </div>
            <div className="card-body">
              <h4 className="card-text">
                African Diversified Art Odyssey Group
              </h4>
              <p>
                <i>Art, Collections, Sales</i>
              </p>
              <p>React Js, Bootstrap </p>
              <a href="https://adao-group.com" target="_blank" rel="noreferrer">
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/adao-website"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Complete</div>
            <div className="card-image">
              <img src={adera} className="card-img-top" alt="adera" />
            </div>
            <div className="card-body">
              <h4 className="card-text">Adera Ventures</h4>
              <p>
                <i>Consulting, Strategy, Growth</i>
              </p>
              <p>ReactJs, Bootstrap</p>
              <a
                href="https://adera-ventures-website.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a href="#" target="_blank" rel="noreferrer">
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Complete</div>
            <div className="card-image">
              <img src={ecommerce} className="card-img-top" alt="art-site" />
            </div>
            <div className="card-body">
              <h4 className="card-text">Sneakers Collections</h4>
              <p>
                <i>E-Commerce, Sales, Online shopping</i>
              </p>
              <p>React Js</p>
              <a
                href="https://ecommerce-store-neon.vercel.app"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/ecommerce-store"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Complete</div>
            <div className="card-image">
              <img src={travelapp} className="card-img-top" alt="art-site" />
            </div>
            <div className="card-body">
              <h4 className="card-text">Travel Diary App (To-Do)</h4>
              <p>
                <i>Organizer, To-do list</i>
              </p>
              <p>React Js</p>
              <a
                href="https://travel-app-blue-xi.vercel.app"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/travel-app"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Published</div>
            <div className="card-image">
              <img src={school} className="card-img-top" alt="tech-accent" />
            </div>
            <div className="card-body">
              <h4 className="card-text">Tech Accent Website</h4>
              <p>
                <i>EduTech, Digital Agency</i>
              </p>
              <p>React Js, Bootstrap </p>
              <a
                href="https://techaccentng.com"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/TA-Website"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">In Progress</div>
            <div className="card-image">
              <img src={postit} className="card-img-top" alt="blog-site" />
            </div>
            <div className="card-body">
              <h4 className="card-text">PostIt Blog Site</h4>
              <p>
                <i>Blog, Information, News</i>
              </p>
              <p>React Js, Bootstrap </p>
              <a
                href="https://postit-blog-k52j.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/postit-blog"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Complete</div>
            <div className="card-image">
              <img
                src={testimonial}
                className="card-img-top"
                alt="testominals"
              />
            </div>
            <div className="card-body">
              <h4 className="card-text">Testimonial App</h4>
              <p>
                <i>SaaS, FinTech</i>
              </p>
              <p>React Js, Bootstrap</p>
              <a
                href="https://testimonial-app-one.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/testimonial-app"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Complete</div>
            <div className="card-image">
              <img src={room} className="card-img-top" alt="room furniture" />
            </div>
            <div className="card-body">
              <h4 className="card-text">Room App</h4>
              <p>
                <i>Furniture, Lifestyle</i>
              </p>
              <p>HTML, CSS, JavaScript</p>
              <a
                href="https://room-website-lyart.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/room-website"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Complete</div>
            <div className="card-image">
              <img src={timer} className="card-img-top" alt="timer" />
            </div>
            <div className="card-body">
              <h4 className="card-text">'Coming Soon' Page</h4>
              <p>
                <i>Landing page, Countdown timer</i>
              </p>
              <p>HTML, CSS, JavaScript</p>
              <a
                href="https://countdown-timer-ebon.vercel.app/ "
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a href="#" target="_blank" rel="noreferrer">
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Complete</div>
            <div className="card-image">
              <img src={nasims} className="card-img-top" alt="nasims" />
            </div>
            <div className="card-body">
              <h4 className="card-text">NASIMS</h4>
              <p>
                <i>Finance, Management</i>
              </p>
              <p>HTML, CSS, Bootstrap </p>
              <a
                href="https://nasims-project.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a href="#" target="_blank" rel="noreferrer">
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Complete</div>
            <div className="card-image">
              <img src={meet} className="card-img-top" alt="social" />
            </div>
            <div className="card-body">
              <h4 className="card-text">Meet App</h4>
              <p>
                <i>Community, Social</i>
              </p>
              <p>React JS </p>
              <a
                href="https://meet-react-eta.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/meet-class"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Complete</div>
            <div className="card-image">
              <img src={huddle} className="card-img-top" alt="social" />
            </div>
            <div className="card-body">
              <h4 className="card-text">Huddle App</h4>
              <p>
                <i>Community, Social</i>
              </p>
              <p>React Js, Bootstrap </p>
              <a
                href="https://huddle-project-ten.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/huddle-project"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">Complete</div>
            <div className="card-image">
              <img src={portfolio2} className="card-img-top" alt="game" />
            </div>
            <div className="card-body">
              <h4 className="card-text">Guess My Number App</h4>
              <p>
                <i>Fun, Personal</i>
              </p>
              <p>HTML, CSS, JavaScript </p>
              <a
                href="https://profoundguess.netlify.app"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/guess-my-number"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>

          <div className="card">
            <div className="card-header">In Progress</div>
            <div className="card-image">
              <img src={onefunnel} className="card-img-top" alt="sales app" />
            </div>
            <div className="card-body">
              <h4 className="card-text">One Funnel Website Clone</h4>
              <p className="text-muted">
                <i>Sales, Clone</i>
              </p>
              <p>HTML, CSS, JavaScript</p>
              <a
                href="https://one-funnel-app.vercel.app/"
                target="_blank"
                rel="noreferrer"
              >
                <span>View Website</span>
              </a>
              <br />
              <a
                href="https://github.com/lanreonasanya02/one-funnel-app"
                target="_blank"
                rel="noreferrer"
              >
                <span>View GitHub</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Portfolio;
